'use client';

import { FC } from 'react';
import { Carousel, Slide } from 'atoms/Carousel';
import { VideoPlayer } from 'molecules/VideoPlayer';
import { Product } from 'commerce/scayle/utils/adapter';
import styles from './styles.module.css';

export const ProductVideoSlider: FC<{ videos: Product['video'] }> = ({
  videos,
}) => {
  return (
    <Carousel
      slidesPerView={1}
      spaceBetween={0}
      navigation={{ enabled: true }}
      className={styles.slider}
    >
      {videos.map((url) => (
        <Slide key={url} className={styles.slide}>
          {({ isActive }) =>
            isActive && (
              <div className={styles.videoWrapper}>
                <VideoPlayer url={url} isSlider />
              </div>
            )
          }
        </Slide>
      ))}
    </Carousel>
  );
};
